import React, { useState } from 'react';
import { getPublicName } from './UserProfile';

const AVATAR_COLORS = [
  '#3b82f6',
  '#0d9488',
  '#6366f1',
  '#0891b2',
  '#059669',
  '#64748b',
  '#7c3aed',
  '#2563eb',
  '#0f766e',
  '#475569',
];

export function getAvatarInitials(name, fallback = 'M') {
  const normalized = String(name || '').trim();
  if (!normalized) return fallback.slice(0, 1).toUpperCase();

  const parts = normalized.split(/\s+/).filter(Boolean);
  if (parts.length === 1) return parts[0].slice(0, 1).toUpperCase();
  return `${parts[0].slice(0, 1)}${parts[1].slice(0, 1)}`.toUpperCase();
}

export function getAvatarBackgroundColor(seed = '') {
  const value = String(seed || 'member');
  let hash = 0;
  for (let i = 0; i < value.length; i += 1) {
    hash = value.charCodeAt(i) + ((hash << 5) - hash);
  }
  return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length];
}

function UserAvatar({
  profile = null,
  userId = '',
  name = '',
  size = 36,
  alt = '',
  className = '',
  style = {},
  borderWidth = 1,
}) {
  const [imageFailed, setImageFailed] = useState(false);
  const displayName = name || getPublicName(profile, 'Member');
  const photoUrl = profile?.profilePhotoUrl;
  const showPhoto = Boolean(photoUrl) && !imageFailed;
  const initials = getAvatarInitials(displayName);
  const backgroundColor = getAvatarBackgroundColor(userId || displayName);
  const fontSize = Math.max(10, Math.round(size * 0.38));
  const ariaLabel = alt || `${displayName} avatar`;

  if (showPhoto) {
    return (
      <img
        src={photoUrl}
        alt={ariaLabel}
        className={`user-avatar user-avatar-image ${className}`.trim()}
        onError={() => setImageFailed(true)}
        style={{
          width: size,
          height: size,
          borderRadius: '50%',
          objectFit: 'cover',
          border: `${borderWidth}px solid #e5e7eb`,
          flexShrink: 0,
          ...style,
        }}
      />
    );
  }

  return (
    <span
      className={`user-avatar user-avatar-initials ${className}`.trim()}
      role="img"
      aria-label={ariaLabel}
      style={{
        width: size,
        height: size,
        borderRadius: '50%',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor,
        color: '#ffffff',
        fontWeight: '700',
        fontSize,
        letterSpacing: '0.02em',
        border: `${borderWidth}px solid #e5e7eb`,
        flexShrink: 0,
        userSelect: 'none',
        lineHeight: 1,
        ...style,
      }}
    >
      {initials}
    </span>
  );
}

export default UserAvatar;